import {
	Box,
	Card,
	Paper,
	Skeleton,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";

export function PartnerCalendarSkeleton() {
	return (
		<Stack spacing={2}>
			<Card sx={{ p: 2 }}>
				{/* Header: Month nav and Legend */}
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					mb={2}
				>
					<Stack direction="row" alignItems="center" spacing={1}>
						<Skeleton variant="circular" width={40} height={40} />
						<Skeleton variant="text" width={150} height={32} />
						<Skeleton variant="circular" width={40} height={40} />
					</Stack>
					<Skeleton variant="rectangular" width={200} height={24} />
				</Stack>

				{/* Controls: Filters and Save button */}
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					mb={2}
					spacing={2}
				>
					<Stack direction="row" spacing={2} flex={1}>
						<Skeleton variant="rectangular" width={150} height={40} />
					</Stack>
					<Skeleton variant="rectangular" width={140} height={40} />
				</Stack>

				{/* Calendar Grid Skeleton */}
				<TableContainer
					component={Paper}
					elevation={0}
					variant="outlined"
					sx={{ borderRadius: 2, border: "1px solid #e0e0e0" }}
				>
					<Table size="medium">
						<TableHead>
							<TableRow>
								<TableCell
									sx={{
										width: 280,
										minWidth: 280,
										position: "sticky",
										left: 0,
										backgroundColor: "background.paper",
										zIndex: 10,
									}}
								>
									<Skeleton variant="text" width={100} />
								</TableCell>
								{Array.from({ length: 15 }).map((_, i) => (
									<TableCell key={i} align="center" sx={{ minWidth: 50 }}>
										<Skeleton variant="text" width={20} sx={{ mx: "auto" }} />
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{Array.from({ length: 5 }).map((_, rowIndex) => (
								<TableRow key={rowIndex}>
									<TableCell
										sx={{
											position: "sticky",
											left: 0,
											backgroundColor: "background.paper",
											zIndex: 10,
											borderRight: "1px solid #e0e0e0",
										}}
									>
										<Stack direction="row" spacing={2} alignItems="center">
											<Box>
												<Skeleton variant="text" width={150} />
												<Skeleton variant="text" width={100} height={15} />
											</Box>
										</Stack>
									</TableCell>
									{Array.from({ length: 15 }).map((_, colIndex) => (
										<TableCell
											key={colIndex}
											sx={{ p: 0.5, borderRight: "1px dashed #e5e7eb" }}
										>
											<Skeleton
												variant="rectangular"
												width={40}
												height={40}
												sx={{ mx: "auto", borderRadius: 1 }}
											/>
										</TableCell>
									))}
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>

				{/* Pagination */}
				<Stack direction="row" justifyContent="flex-end" mt={2}>
					<Skeleton variant="rectangular" width={300} height={40} />
				</Stack>
			</Card>
		</Stack>
	);
}
